import { postApi } from 'api/fetchApi'
import { definitions } from 'api/generated/promo_codes'

export const applyPromoCodeApi = (promoCode: string) => {
  return postApi<
    unknown,
    definitions['PromoCodesApplyPromoCodePostBodyRequest']
  >('/promocodes/apply', { promoCode })
}
